export default "__VITE_ASSET__C4rz2qm$__"